import React, { useEffect, useState, useCallback } from "react";
import agent from "../../app/api/agent";
import useToaster from "../../app/hooks/useToaster";
import PaginationComponent from "../../components/pagination/Pagination";
import { InternshipWithApplications } from "./types";

const useMyInternships = (past: boolean) => {
  const [internships, setInternships] = useState<InternshipWithApplications[]>([]);
  const [totalPages, setTotalPages] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalCount, setTotalCount] = useState<number | undefined>(undefined);
  const [isLoading, setLoading] = useState(true);
  const { apiError } = useToaster();

  const loadInternships = useCallback(
    async (page: number) => {
      setLoading(true);

      try {
        const response = await agent.Internships.listMyInternships({ past }, page);
        setInternships(response.items);
        setTotalPages(response.totalPages);
        setTotalCount(response.totalCount);
      } catch (error) {
        setInternships([]);
        apiError(error);
      } finally {
        setLoading(false);
      }
    },
    [apiError, past]
  );

  useEffect(() => {
    setTotalCount(undefined);
    setPageNumber(1);
    loadInternships(1);
  }, [loadInternships]);

  const handlePageChange = (page: number) => {
    setPageNumber(page);
    loadInternships(page);
  };

  const renderPagination = () => (
    <PaginationComponent totalPages={totalPages} pageNumber={pageNumber} handlePageChange={handlePageChange} />
  );

  return {
    internships,
    isLoading,
    totalCount,
    reload: () => loadInternships(pageNumber),
    renderPagination,
  };
};

export default useMyInternships;
